import { BackendClient, type BackendTypes } from '@tf/api';

export const getOverviewQuery = async (
	params: BackendTypes.GetOverviewParams,
): Promise<BackendTypes.GetOverviewData> => {
	const res = await BackendClient.getInstance().getOverview(params);
	return res.json();
};
